import { EffectCallback, useEffect } from 'react'

export function useOnUnmount(callback: ReturnType<EffectCallback>) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => callback, [])
}
